import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import UserAvatar from './UserAvatar';
import { userDisplayLabel } from '../utils/userDisplayLabel';
import '../App.css';

const Navbar = ({ user, logout, sidebarOpen, onToggleSidebar, isMobile: isMobileProp }) => {
  const [isMobileState, setIsMobileState] = useState(window.innerWidth <= 768);
  const isMobile = isMobileProp !== undefined ? isMobileProp : isMobileState;

  useEffect(() => {
    if (isMobileProp !== undefined) return;
    const handleResize = () => setIsMobileState(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobileProp]);

  const hamburgerSpanStyle = {
    width: '20px',
    height: '2px',
    background: 'var(--logo-cyan-teal)',
    borderRadius: '2px',
    boxShadow: '0 0 6px rgba(51, 255, 217, 0.8), 0 0 10px rgba(181, 255, 51, 0.4)',
    transition: 'all 0.2s ease'
  };

  return (
    <nav className="navbar">
      <div
        className="navbar__start"
        style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginLeft: !isMobile ? (sidebarOpen ? '256px' : '64px') : '0',
        transition: 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        minWidth: 0,
        flex: '1 1 auto'
      }}
      >
        {!sidebarOpen && onToggleSidebar && isMobile && (
          <button
            type="button"
            onClick={onToggleSidebar}
            className="navbar-mobile-menu-btn"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '5px',
              width: 44,
              height: 44,
              minWidth: 44,
              minHeight: 44,
              padding: 0,
              border: '2px solid var(--logo-cyan-teal)',
              borderRadius: '8px',
              background: 'transparent',
              cursor: 'pointer',
              boxShadow: '0 0 12px rgba(51, 255, 217, 0.4)'
            }}
            aria-label="Open menu"
            title="Open menu"
          >
            <span style={hamburgerSpanStyle} />
            <span style={hamburgerSpanStyle} />
            <span style={hamburgerSpanStyle} />
          </button>
        )}
        {!sidebarOpen && (
          <Link to="/" className="navbar-brand" style={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0 }}>
            <img 
              src="/logo-labster-banner.jpeg" 
              alt="THE LABSTER" 
              style={{ 
                height: '40px', 
                width: 'auto',
                maxWidth: '100%'
              }} 
            />
            <span style={{ display: 'none' }}>THE LABSTER</span>
          </Link>
        )}
      </div>
      <div className="navbar-nav" style={{ flexShrink: 0 }}>
        {user && (
          <>
            <span
              className="nav-link"
              style={{
                color: 'var(--logo-cyan-teal)',
                fontWeight: '600',
                fontSize: isMobile ? '0.8125rem' : '0.9375rem',
                maxWidth: isMobile ? '200px' : 'none',
                overflow: isMobile ? 'hidden' : 'visible',
                textOverflow: isMobile ? 'ellipsis' : 'clip',
                whiteSpace: isMobile ? 'nowrap' : 'normal',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px'
              }}
            >
              <UserAvatar photoUrl={user.profilePhotoUrl} label={userDisplayLabel(user)} size={isMobile ? 32 : 36} />
              <span>
                {isMobile ? (
                  <>
                    {user?.name?.split(' ')[0] || user?.name} ({user?.role?.charAt(0).toUpperCase()})
                  </>
                ) : (
                  <>
                    {user?.name} ({user?.role})
                  </>
                )}
              </span>
            </span>
            <button 
              onClick={logout} 
              className="btn btn-outline" 
              style={{ 
                padding: isMobile ? '10px' : '8px 12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: isMobile ? '44px' : '40px',
                minHeight: isMobile ? '44px' : '40px',
                height: isMobile ? '44px' : '40px'
              }}
              aria-label="Logout"
              title="Logout"
            >
              <span style={{ fontSize: isMobile ? '1.1rem' : '1.2rem' }}>⏻</span>
            </button>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;

